import { TransactionFilters } from "@common/schemas/transaction.schema";

type SnapshotBatchFilters = Pick<
    TransactionFilters,
    | "entityIds"
    | "transactionIds"
    | "isUnreconciledCheck"
    | "includeBeforeBookkeepingStart"
>;

interface GetSnapshotBatchFiltersParams {
    filters: TransactionFilters;
    transactionIds: number[];
}

/**
 * Filters for loading a batch of id-snapshot rows by id. The snapshot ids
 * already apply every narrowing filter; `isUnreconciledCheck` and
 * `includeBeforeBookkeepingStart` are carried because together they widen the
 * default bookkeeping-date scope.
 */
export function getSnapshotBatchFilters({
    filters,
    transactionIds,
}: GetSnapshotBatchFiltersParams): SnapshotBatchFilters {
    return {
        entityIds: filters.entityIds,
        transactionIds,
        isUnreconciledCheck: filters.isUnreconciledCheck,
        includeBeforeBookkeepingStart: filters.includeBeforeBookkeepingStart,
    };
}
